import React from 'react';
import classNames from 'classnames';
import Image from 'next/image';
import { sanitizeHTML } from '@benzinga/frontend-utils';
import { Image as ArticleImage } from '@benzinga/article-manager';
import styles from './ImagePlacement.module.scss';

export interface ImagePlacementProps {
  title?: string;
  caption?: string;
  primaryImage: ArticleImage;
}

export const ImagePlacement: React.FC<ImagePlacementProps> = ({ caption, primaryImage, title }) => {
  const alt = caption || '';
  if (primaryImage) {
    const primaryImageURL = primaryImage.url?.replace('//www.benzinga', '//cdn.benzinga');
    return (
      <figure className={classNames(styles.container, 'image-placement')}>
        <div className="article-image bg-gray-100">
          <Image
            alt={alt}
            blurDataURL={`${primaryImageURL}?width=50`}
            fill
            placeholder="blur"
            priority
            sizes="(max-width: 800px) 120px, (min-width: 800px) 400px"
            src={primaryImageURL}
            style={{ objectFit: 'cover' }}
            title={title}
          />
        </div>
        {caption && (
          <figcaption className="image-caption" dangerouslySetInnerHTML={{ __html: sanitizeHTML(caption) }} />
        )}
      </figure>
    );
  }

  return <div />;
};
